var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: true,
//         addCollectionToProductUrl: false,
		filterTreeMobileStyle: 'style1',
//       	urlScheme: 1,
      	capitalizeFilterOptionValues: false,
  	},
};

(function() {

	BoostPFS.inject(this);
  
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data, index, totalProduct) {
      	if (!data) data = this.data;
      	if (!index) index = this.index + 1;
      	if (!totalProduct) totalProduct = this.totalProduct;
      
        /*** Prepare data ***/
        var images = data.images_info;
         // Displaying price base on the policy of Shopify, have to multiple by 100
        var soldOut = !data.available; // Check a product is out of stock
        var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
        var priceVaries = data.price_min != data.price_max; // Check a product has many prices
        // Get First Variant (selected_or_first_available_variant)
        var firstVariant = data['variants'][0];
        if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
            var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
            if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
        } else {
            for (var i = 0; i < data['variants'].length; i++) {
                if (data['variants'][i].available) {
                    firstVariant = data['variants'][i];
                    break;
                }
            }
        }
        /*** End Prepare data ***/

        // Get Template
        var itemHtml = boostPFSTemplate.productGridItemHtml;

        // Add soldOut class
        var soldOutClass = soldOut && boostPFSThemeConfig.custom.label_soldout_enable ? boostPFSTemplate.soldOutClass : '';
        itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

        // Add maxColsClass
        itemHtml = itemHtml.replace(/{{itemMaxCols}}/g, boostPFSThemeConfig.custom.products_per_row);
      	itemHtml = itemHtml.replace(/{{itemMinCols}}/g, boostPFSThemeConfig.custom.mobile_products_per_row);

        // Add itemGridWidthClass
        var itemGridWidthClass = ''
        if (index % 2 == 1) { itemGridWidthClass += 'nth-2 '; }
        if (index % 3 == 1) { itemGridWidthClass += 'nth-3 '; }
        if (index % 4 == 1) { itemGridWidthClass += 'nth-4 '; }
        if (index % 6 == 1) { itemGridWidthClass += 'nth-6 '; }
        itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

        // Add Block layout class
        var blockLayoutClass = boostPFSThemeConfig.custom.block_layout == 'beside' ? boostPFSTemplate.blockLayoutClass : '';
        itemHtml = itemHtml.replace(/{{blockLayoutClass}}/g, blockLayoutClass);

        // Add image hover class
        var imageHoverClass = boostPFSThemeConfig.custom.product_grid_hover_image && images.length > 1 ? 'image--with-secondary' : '';
        itemHtml = itemHtml.replace(/{{imageHoverClass}}/g, imageHoverClass);

        // Add price
        var itemPriceHtml = '';
        var saleClass = onSale ? 'on-sale' : '';
      	itemPriceHtml += '<div class="price ' + saleClass + '">';
        if (priceVaries) {
            itemPriceHtml += boostPFSThemeConfig.label.from_price + ' ';
        }
        itemPriceHtml += '<span class="amount theme-money">' + Utils.formatMoney(data.price_min, Globals.moneyFormat) + '</span>';
        if (onSale) {
            itemPriceHtml += ' <del><span class="theme-money">' + Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat) + '</span></del>';
        }
      	itemPriceHtml += '</div>';
        itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

        // Add vendor
        var itemVendorHtml = boostPFSThemeConfig.custom.grid_show_vendor ? '<div class="vendor">'+ data.vendor +'</div>' : '';
        itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);
      
      	var itemBullet = '';
      	var total = 0;
      	var quantity = data.variants.map(function(e){return e.inventory_quantity + total})
        var total = quantity.reduce((a, b) => a + b, 0)
      	if (total < 1) {
          itemBullet = '<span class="bullet-available grey" title="Not Available"></span>';
        } else {
          itemBullet = '<span class="bullet-available green" title="Available"></span>';
        }
      	itemHtml = itemHtml.replace(/{{itemBullet}}/g, itemBullet);

        // Add Labels
        var itemLabelsHtml = '';
        if (onSale && boostPFSThemeConfig.custom.label_sale_enable) {
            itemLabelsHtml += boostPFSTemplate.saleLabelHtml;
            itemLabelsHtml = itemLabelsHtml.replace(/{{saveAmount}}/g, Utils.formatMoney(data.compare_at_price_max - data.price_min));
            itemLabelsHtml = itemLabelsHtml.replace(/{{percentage}}/g, data.percent_sale_min);
        } else if (boostPFSThemeConfig.custom.label_remain_show && data.variants.length == 1 && data.variants[0].inventory_quantity > 0 && data.variants[0].inventory_quantity <= boostPFSThemeConfig.custom.prod_stock_warn_limit) {
            itemLabelsHtml += '<span class="product-label general"><span>' + boostPFSThemeConfig.label.only_x_left.replace(/{{ quantity }}/g, data.variants[0]['inventory_quantity']) + '</span></span>';
        } else {
            if (soldOut && boostPFSThemeConfig.custom.label_soldout_enable) {
                itemLabelsHtml += boostPFSTemplate.soldOutLabelHtml;
            } else {
                for (var k in data.tags) {
                    var tag = data['tags'][k];
                    if (tag.indexOf('meta-label-') > -1) {
                        itemLabelsHtml += '<span class="product-label general"><span>' + tag.replace('meta-label-', '') + '</span></span>';
                    }
                }
            }
        }
        itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

        // Add Quickview
        var itemQuickViewHtml = '';
        if (boostPFSThemeConfig.custom.prod_quick_buy_show) {
          	if (data.variants.length > 1) {
              	itemQuickViewHtml += '<div class="product-form">';
              	if (soldOut) {
                    itemQuickViewHtml += '<a class="quick-buy btn disabled" href="{{itemUrl}}" data-product-id="{{itemId}}">';
                    itemQuickViewHtml += boostPFSThemeConfig.label.soldout;
                    itemQuickViewHtml += '</a>';
                } else {
                  	itemQuickViewHtml += '<a class="quick-buy btn disabled" href="{{itemUrl}}" data-product-id="{{itemId}}">';
                    itemQuickViewHtml += boostPFSThemeConfig.label.options;
                    itemQuickViewHtml += '</a>';
                }
            } else {
              	itemQuickViewHtml += '<form method="post" action="/cart/add" id="product_form_{{itemId}}" accept-charset="UTF-8" class="product-form product-form--mini" enctype="multipart/form-data" data-ajax-add-to-cart="true" data-open-cart-drawer="true" data-product-id="{{itemId}}">';
                itemQuickViewHtml += '<input type="hidden" name="form_type" value="product">';
                itemQuickViewHtml += '<input type="hidden" name="utf8" value="✓">';
                itemQuickViewHtml += '<input type="hidden" name="quantity" value="1">';
                itemQuickViewHtml += '<input type="hidden" name="id" value="' + data.variants[0].id + '">';
                itemQuickViewHtml += '<button type="submit" name="add" class="btn product-add" aria-live="polite">';
                itemQuickViewHtml += '<span class="button-text">Add to cart</span>';
                itemQuickViewHtml += '<span class="loading-spinner" aria-label="Adding"></span>';
                itemQuickViewHtml += '<span class="added-to-cart-check" aria-label="Added to cart"></span>';
                itemQuickViewHtml += '</button>';
                itemQuickViewHtml += '</form>';
              
              	itemQuickViewHtml += '<div class="qty-adjuster-container">';              
                itemQuickViewHtml += '<div class="qty-adjuster qty-adjuster--ajax"';
              	if (data.variants[0].inventory_management == 'shopify' && data.variants[0].inventory_policy == 'deny') {
                  itemQuickViewHtml += ' data-limit="' + data.variants[0].inventory_quantity + '" ';
                }              	
              	itemQuickViewHtml += '>';
                itemQuickViewHtml += '<div class="qty-adjuster__inner">';
                itemQuickViewHtml += '<button class="btn qty-adjuster__down" aria-label="Decrease"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus"><line x1="5" y1="12" x2="19" y2="12"></line></svg></button>';
                itemQuickViewHtml += '<input class="qty-adjuster__value" type="text" pattern="[0-9]*" name="quantity" value="" aria-label="Quantity">';
                itemQuickViewHtml += '<button class="btn qty-adjuster__up" aria-label="Increase"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg></button>';
                itemQuickViewHtml += '</div>';
                itemQuickViewHtml += '</div>';
                itemQuickViewHtml += '</div>';
            }
        }
        itemHtml = itemHtml.replace(/{{itemQuickBuy}}/g, itemQuickViewHtml);
      
      	var itemQuickBuyPlaceholder = '';
        if (boostPFSThemeConfig.custom.prod_quick_buy_show) {
          	itemQuickBuyPlaceholder += '<script type="text/template" class="quickbuy-placeholder-template" data-product-id="{{itemId}}"><div class="quickbuy-form placeholder"><span class="loading-spinner"></span></div></script>';
        }
      	itemHtml = itemHtml.replace(/{{itemQuickBuyPlaceholder}}/g, itemQuickBuyPlaceholder);

        //Add Image
        var itemImgHtml = '';
        var aspectRatio = (boostPFSThemeConfig.custom.prod_thumb_shape != 'natural') ? parseFloat(boostPFSThemeConfig.custom.prod_thumb_shape) : 1;
        var maxWidth = images.length > 0 ? images[0].width : 480;
      	var width = images.length > 0 ? images[0].width : 480;
      	var height = images.length > 0 ? images[0].height : 480;
        itemImgHtml += '<div class="image__primary">' +
                            '<div class="rimage-outer-wrapper" style="max-width:' + maxWidth + 'px">' +
                                '<div class="rimage-wrapper lazyload--placeholder" style="padding-top:' + 1 / aspectRatio * 100 + '%">' +
                                    '<img class="rimage__image" data-lazy-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' + 
                                        ' loading="lazy" width="' + width + '" height="' + height + '"' +
                                        ' alt="{{itemTitle}}" ' +
                                    '/>' +
          							'<noscript>' +
                                        '<img src="' + Utils.getFeaturedImage(images, '1024x1024') + '" alt="{{itemTitle}}" class="rimage__image">' +
                                    '</noscript>' +
                                '</div>' +
                            '</div>'+
                        '</div>';
        if (boostPFSThemeConfig.custom.product_grid_hover_image && images.length > 1) {
            var aspect_ratio = images[1].width / images[1].height;
            itemImgHtml += '<div class="image__secondary">' +
                                '<div class="rimage-outer-wrapper lazyload fade-in" ' +
                                    'data-bgset="' + bgset(images[1]) + '"' +
                                    'data-sizes="auto" data-parent-fit="contain">' +
                                    '<noscript>' +
                                    '<div class="rimage-wrapper" style="padding-top:' + (1 / aspect_ratio * 100) + '%">' +
                                        '<img src="' + Utils.optimizeImage(images[1].src, '1024x') + '" alt="{{itemTitle}}" class="rimage__image">' +
                                    '</div>' +
                                    '</noscript>' +
                                '</div>'+
                            '</div>';
        }
        itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImgHtml);
      
      	var itemSoldOutClass = (soldOut) ? ' sold-out ' :'';
      	itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

        // Add main attribute
        itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
        itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
        itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
        itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
        return itemHtml;
    }

	/************************** END BUILD PRODUCT LIST **************************/
	function buildReview(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
			boostPFSThemeConfig.custom.show_product_review == true) {
			html = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
		}
		return html;
	}
  
  	function bgset(image) {
        var bgset = '';
        if (image) {
            var aspect_ratio = image.width / image.height;

            if (image.width > 180) bgset += ' ' + Utils.optimizeImage(image.src, '180x') + ' 180w ' + Math.round(180 / aspect_ratio) + 'h,';
            if (image.width > 360) bgset += ' ' + Utils.optimizeImage(image.src, '360x') + ' 360w ' + Math.round(360 / aspect_ratio) + 'h,';
            if (image.width > 540) bgset += ' ' + Utils.optimizeImage(image.src, '540x') + ' 540w ' + Math.round(540 / aspect_ratio) + 'h,';
            if (image.width > 720) bgset += ' ' + Utils.optimizeImage(image.src, '720x') + ' 720w ' + Math.round(720 / aspect_ratio) + 'h,';
            if (image.width > 900) bgset += ' ' + Utils.optimizeImage(image.src, '900x') + ' 900w ' + Math.round(900 / aspect_ratio) + 'h,';
            if (image.width > 1080) bgset += ' ' + Utils.optimizeImage(image.src, '1080x') + ' 1080w ' + Math.round(1080 / aspect_ratio) + 'h,';
            if (image.width > 1296) bgset += ' ' + Utils.optimizeImage(image.src, '1296x') + ' 1296w ' + Math.round(1296 / aspect_ratio) + 'h,';
            if (image.width > 1512) bgset += ' ' + Utils.optimizeImage(image.src, '1512x') + ' 1512w ' + Math.round(1512 / aspect_ratio) + 'h,';
            if (image.width > 1728) bgset += ' ' + Utils.optimizeImage(image.src, '1728x') + ' 1728w ' + Math.round(1728 / aspect_ratio) + 'h,';
            if (image.width > 1950) bgset += ' ' + Utils.optimizeImage(image.src, '1950x') + ' 1950w ' + Math.round(1950 / aspect_ratio) + 'h,';
            if (image.width > 2100) bgset += ' ' + Utils.optimizeImage(image.src, '2100x') + ' 2100w ' + Math.round(2100 / aspect_ratio) + 'h,';
            if (image.width > 2260) bgset += ' ' + Utils.optimizeImage(image.src, '2260x') + ' 2260w ' + Math.round(2260 / aspect_ratio) + 'h,';
            if (image.width > 2450) bgset += ' ' + Utils.optimizeImage(image.src, '2450x') + ' 2450w ' + Math.round(2450 / aspect_ratio) + 'h,';
            if (image.width > 2700) bgset += ' ' + Utils.optimizeImage(image.src, '2700x') + ' 2700w ' + Math.round(2700 / aspect_ratio) + 'h,';
            if (image.width > 3000) bgset += ' ' + Utils.optimizeImage(image.src, '3000x') + ' 3000w ' + Math.round(3000 / aspect_ratio) + 'h,';
            if (image.width > 3350) bgset += ' ' + Utils.optimizeImage(image.src, '3350x') + ' 3350w ' + Math.round(3350 / aspect_ratio) + 'h,';
            if (image.width > 3750) bgset += ' ' + Utils.optimizeImage(image.src, '3750x') + ' 3750w ' + Math.round(3750 / aspect_ratio) + 'h,';
            if (image.width > 4100) bgset += ' ' + Utils.optimizeImage(image.src, '4100x') + ' 180w ' + Math.round(4100 / aspect_ratio) + 'h,';
            bgset += ' ' + image.src + ' ' + image.width + 'w ' + image.height + 'h,';
        }
        return bgset;
    }


	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};
  
  	ProductPaginationDefault.prototype._onClickEvent = function(event) {
		event.preventDefault();
		Globals.internalClick = true;

		// Get the new page value
		var url;
		try {
			url = new URL(jQ(event.currentTarget).attr('href'));
		} catch (e) {
			url = new URL('https://' + boostPFSConfig.shop.domain + jQ(event.currentTarget).attr('href'));
		}

		var pageValue = url && url.searchParams ? url.searchParams.get('page') : 1;
		if (!pageValue || isNaN(pageValue)) pageValue = 1;

		// Apply filter
		FilterApi.setParam('page', pageValue);
		FilterApi.applyFilter('page');
      
		// Scroll to top of product list
		theme.viewport.scrollTo({
			top: this.$productList.offset().top - 50,
			behavior: 'smooth'
		});
	}

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
                    sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
                }
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	/************************** END BUILD TOOLBAR **************************/

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;

		// Intergrate Review Shopify
		if (window.SPR &&
			typeof window.SPR.initDomEls == 'function' &&
			typeof window.SPR.loadBadges == 'function' &&
			boostPFSThemeConfig.custom.show_product_review) {
			window.SPR.initDomEls();
			window.SPR.loadBadges();
		}
      
      	var html = '<div class="product-block product-block--flex-spacer flex column max-cols-' + boostPFSThemeConfig.custom.products_per_row + ' min-cols-' + boostPFSThemeConfig.custom.mobile_products_per_row + '"></div>';
      	for (var i = 0; i < boostPFSThemeConfig.custom.products_per_row; i++) {
          	jQ(Selector.products).append(html);
        }
      	
	};

	// Build additional elements
	Filter.prototype.afterRender = function(data) {
		if (!data) data = this.data;

		jQ('.results-count').html(boostPFSThemeConfig.label.products_count.replace(/{{ count }}/g, data.total_product));
      
      	theme.Sections.init();
        theme.Sections.register('collection-template', theme.CollectionTemplateSection, {
          deferredLoad: false
        });
      
        jQ('.boost-pfs-filter-toggle').off('click').on('click', function(e) {
          e.preventDefault();
          jQ('.collection-page').removeClass('cc-filters-closed-no-trans');
          
          if (theme.viewport.isXs()) {
            jQ('.collection-page').toggleClass('cc-filters-mob-open');
          } else {
            jQ('.collection-page').toggleClass('cc-filters-closed');
          }
      	});
      
      	jQ('.boost-pfs-filter-close').off('click').on('click', function() {
          jQ('.collection-page').removeClass('cc-filters-mob-open');
      	});      	
      
      	if (Utils.isMobile() && boostPFSFilterConfig.general.filterTreeMobileStyle == 'style1') {
            jQ('body').addClass('boost-pfs-filter-tree-open-body');
        }
	};
  
  	FilterScrollToTop.prototype.scrollToTop = function() {
		theme.viewport.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	}
})();